import { useDispatch, useSelector } from "react-redux";
import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  removeObjekt,
  setObjekte,
  setObjektOnEdit,
} from "../../Redux/Actions/objekteMuzealeActions";

const ManageObjekteMuzeale = () => {
  const dispatch = useDispatch();
  const [objektet, setObjektet] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser).length > 0;
  const navigate = useNavigate();

  if (!isLoggedIn) navigate("/login");

  useEffect(() => {
    const fetchObjekteMuzeale = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.arkiva.gov.al/api/objekteMuzeale?page=${currentPage}&limit=20`
        );
        setObjektet(response.data.objekte);
        setTotalPages(response.data.totalPages);
        dispatch(setObjekte(response.data.objekte));
      } catch (error) {
        console.error("Error fetching objekte muzeale:", error);
      }
      setLoading(false);
    };

    if (isLoggedIn) {
      fetchObjekteMuzeale();
    } else {
      navigate("/login");
    }
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  if (!isLoggedIn) {
    return null;
  }

  const editObjektMuzeal = (objekt) => {
    navigate(`/manage/objekte-muzeale/${objekt._id}`);
    dispatch(setObjektOnEdit(objekt));
  };

  const addObjekt = () => {
    navigate("/manage/objekte-muzeale/add-new");
  };

  const deleteObjektMuzeal = async (objekt) => {
    try {
      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/objekteMuzeale/delete/${objekt._id}`
      );
      if (response.data.message === "error") {
        alert("Something went wrong!");
      } else {
        setObjektet((prevObjektet) =>
          prevObjektet.filter((obj) => obj._id !== response.data.objektId)
        );
        dispatch(removeObjekt(response.data.objektId));
      }
    } catch (error) {
      console.error("Error deleting objekt muzeal:", error);
    }
  };

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={addObjekt}>
            <i className="fa-solid fa-plus"></i>Shto Objekt
          </button>
        </div>
      </div>
      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Titulli</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {objektet.length > 0 ? (
              objektet.map((item, index) => (
                <tr key={index}>
                  <td data-label="Titulli">{item.title}</td>
                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editObjektMuzeal(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button onClick={() => deleteObjektMuzeal(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nuk u gjetën objekte muzeale!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          &#8592; Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManageObjekteMuzeale;
